class DataFilterService {
  /** ***************** DELETE ONCE FILTER BAR IS NOT USED DIRECTLY ***************** **/

  /**
   * @deprecated
   * Build a list of filters ready to be passed to the FilterBar component
   *
   * @param {object[]} data Array of objects containing the field data
   * @param {object[]} fields Array of objects containing the fields to create filters for
   * @param {object} labelMappings Mapping values into the raw data to labels to display in filters
   * @param {string[]} hiddenFields Array of field names to hide
   */
  buildFilters (data, fields, labelMappings = {}, hiddenFields = []) {
    const distinctValues = this.getDistinctValues(data, fields.map(({ key }) => key))
    return distinctValues.map(({ field, values }) => {
      const { type, label } = fields.find(({ key }) => key === field) || {}
      const filter = {
        key: field,
        type,
        label: label || field,
        values: values.map((value) => ({ value, label: labelMappings[value] || value })),
        hidden: hiddenFields.includes(field)
      }
      // Select the first option by default
      filter.selectedValue = (filter.values.length) ? filter.values[0].value : null
      return filter
    })
  }

  /**
   * @deprecated
   * Build a query object to be used for filtering down the raw data
   *
   * @param {object[]} filters Array of filters containing the selected value
   * @param {string[]} emptyFields Array of fields expected to be empty
   * @param {string[]} notEmptyFields Array of fields expected to be not empty
   */
  buildQuery (filters, emptyFields = [], notEmptyFields = []) {
    filters = filters.filter((f) => !f.hidden)
    return {
      equals: filters.map(({ key, selectedValue }) => ({ field: key, value: selectedValue })),
      empty: emptyFields,
      notEmpty: notEmptyFields
    }
  }

  /**
   * @deprecated
   * Filter the data based on the query produced from selecting values on the FilterBar component
   *
   * @param {object[]} data Array of objects containing the field data
   * @param {object} query Query object containing equal, empty, and not empty conditions
   * @param {string} emptyValue Value representing empty (ie, NA from a R produced dataset)
   */
  getFilteredValues (data, query, emptyValue) {
    const { equals = {}, notEmpty = [], empty = [] } = query
    const results = data.filter((r) => (
      notEmpty.every((f) => r[f] !== emptyValue) &&
      empty.every((f) => r[f] === emptyValue) &&
      equals.every(({ field, value }) => r[field] === value)
    ))
    return results
  }

  /** ***************** END ***************** **/

  /**
   * Return the distinct values for the given fields
   *
   * @param {array} data Array of objects containing field values
   * @param {array} fields Array of strings containing the field names to get distinct values of
   * @returns {array} Array of objects with field name and array of values
   */
  getDistinctValues (data = [], fields = []) {
    const results = fields.map((field) => ({ field, values: new Set() }))
    data.forEach((r) => {
      results.forEach(({ field, values }) => {
        values.add(r[field])
      })
    })
    return results.map(({ field, values }) => ({ field, values: Array.from(values) }))
  }
}

export const dataFilterService = new DataFilterService()
